'use strict';

/**
 * VideoTeaser
 *
 * @author Zorica Janjic <zorica.janjic@namics.com>
 */
T.Module.VideoTeaser = T.createModule({

	_selectors: {
		link: '[data-js-m-video-teaser-link]'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);
		this.$videoLink = this.$ctx.find(this._selectors.link);
		this.videoType = this.$ctx.data('video-type');
		this.videoUrl = this.$ctx.data('video-url');

		this.initializeComponent();

		resolve();
	},


	/**
  * Initializing the component
  *
  * Please note: this method get's overridden in the decorator
  *
  * @returns {void}
  */
	initializeComponent: function initializeComponent() {
		this.initLightbox();
	},


	/**
  *  Initializing Magnific Popup Lightbox
  *
  * @returns {undefined} void
  */
	initLightbox: function initLightbox() {
		// Fail if link not found
		if (!this.$videoLink.length) {
			return;
		}

		// Fail if jQuery Plugin not available
		if (!$.magnificPopup) {
			return;
		}

		var closeButtonMarkup = '\n\t\t\t<button title=\'%title%\' class=\'mfp-close\'>\n\t\t\t\t<svg class=\'a-icon a-icon--primary i i-close\'>\n\t\t\t\t\t<use xmlns:xlink=\'http://www.w3.org/1999/xlink\' xlink:href=\'#close\'></use>\n\t\t\t\t</svg>\n\t\t\t</button>';

		var options = {
			// Implementing custom close icon instead of library's default one.
			closeMarkup: closeButtonMarkup,
			fixedContentPos: true,
			fixedBgPos: true
		};

		if (this.videoType === 'native') {
			var videoMarkup = '\n\t\t\t\t<div class="mfp-video">\n\t\t\t\t\t<video controls autoplay name="media">\n\t\t\t\t\t\t<source src="' + this.videoUrl + '" type="video/mp4">\n\t\t\t\t\t</video>\n\t\t\t\t</div>';
			var optionsNative = {
				items: {
					src: videoMarkup,
					type: 'inline'
				}
			};

			$.extend(options, optionsNative);
		} else {
			// Documentation Magnifique Popup: https://dimsemenov.com/plugins/magnific-popup/documentation.html#iframe-type
			// Used property `markup` to solve autoplay issue see ../README.md
			// HTML markup of popup, `mfp-close` will be replaced by the close button
			var optionsIframe = {
				type: 'iframe',
				iframe: {
					markup: '\n\t\t\t\t\t<div class="mfp-iframe-scaler">\n\t\t\t\t\t\t<div class="mfp-close"></div>\n\t\t\t\t\t\t<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen"></iframe>\n\t\t\t\t\t</div>\n\t\t\t\t\t',
					patterns: {
						youtube: {
							// String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
							index: 'youtube.com/',

							// null - full URL will be returned in %id%
							id: null,

							// Full URL that will be set as a source for iframe and adding some parameters.
							src: '%id%?autoplay=1&rel=0'
						},
						srcAction: 'iframe_src'
					}
				}
			};

			$.extend(options, optionsIframe);
		}

		// Apply jQuery Plugin
		this.$videoLink.magnificPopup(options);
	}
});